import React from "react";
import "../Pages/CSS/ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <h2>Contact Us</h2>

      <div className="contact-content">

        {/* ------------------ Contact Info ------------------ */}
        <div className="contact-info">
          <h3>Our Address</h3>
          <p>Address: Malkabad Shopping Center , Ground Floor ,Shop #G-41 6th Road Rawalpindi</p>

          <h3>Email</h3>
          <p>
            <a href="mailto:khanCollection@gmail.com">
              Bazaartvteam@gmail.com
            </a>
          </p>

          <h3>Phone</h3>
          <p>
            <a href="tel:+923365338714">+92336-533-8714</a>
            <a href="tel:+923346076709">+92334-607-6709</a>
          </p>
        </div>

        {/* ------------------ Google Map ------------------ */}
        {/* <div className="contact-map">
          <iframe
            title="Khan Collection Store"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3405.123456789!2d74.3571!3d31.5204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391904c123456789%3A0xabcdef1234567890!2s21%20Km%20Ferozepur%20Road%2C%20Lahore%2C%20Pakistan!5e0!3m2!1sen!2s!4v1234567890"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div> */}
        <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "500px",
        height: "450px",
        margin: "auto",
      }}
    >
      <iframe
        src="https://www.google.com/maps/embed/v1/place?q=Malkabad%20Shopping%20Center%20%2C%20Ground%20Floor%20%2CShop%20%23G-95%206th%20Road%20Rawalpindi&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
        style={{
          width: "100%",
          height: "100%",
          border: 0,
        }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Malkabad Shopping Center Map"
      />
    </div>
      </div>
    </div>
  );
};

export default ContactUs;
